import i18next from "i18next";

export const getWeighValue = (doesWeigh: boolean, value: any, unit?: string, decimalPlaces?: number): string => {
  if (!doesWeigh) return "N/A";

  if (typeof value === "string") value = parseFloat(value);
  if (isNaN(value)) return "N/A";

  if (decimalPlaces !== undefined && decimalPlaces >= 0) {
    const factor = Math.pow(10, decimalPlaces);
    value = Math.round(value * factor) / factor;
  }

  let formatted = new Intl.NumberFormat(i18next.language, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(value);

  formatted = formatted.replace(/\u202F/g, " ");

  return unit ? `${formatted} ${unit}` : formatted;
};
